// import ReactImg from './images/react.png'

export const Footer = () => {
  return (
    <div className="footer p-5 w-full md:fixed bottom-0">
        <p className="flex justify-center items-center">
            Created with 
            <span>
                <img src='/images/react.png' alt="" />
            </span>
        </p>
    </div>
  )
}
